import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';
import api from '../services/api';

// Criar o contexto de autenticação
const AuthContext = createContext();

// Hook personalizado para usar o contexto de autenticação
export const useAuth = () => useContext(AuthContext);

// Provedor do contexto de autenticação
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Verificar se o usuário já está autenticado ao carregar a página
  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('token');
      
      if (token) {
        try {

          
          // Configurar o token no cabeçalho das requisições
          api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          // axios.defaults.headers.common['Authorization'] = `Bearer ${token}`; // A instância 'api' já é configurada
          
          // Usar a instância 'api' que já tem a baseURL correta

          const verifyResponse = await api.get('/auth/verify-token', {
            // O token já deve estar nos headers padrões da instância 'api' se foi setado no login
            // Mas podemos garantir que ele seja enviado, especialmente se esta for a primeira chamada após recarregar a página
            headers: { 
              'Authorization': `Bearer ${token}`
            },
            timeout: 10000 // Aumentar timeout para verificação inicial
          });

          if (verifyResponse && verifyResponse.data && verifyResponse.data.valid) {

            setUser(verifyResponse.data.user);
          } else {
            console.warn('Token inválido ou expirado');
            // Token inválido, fazer logout
            logout();
          }
        } catch (error) {
          console.error('Erro ao verificar autenticação:', error);
          // Em caso de erro, fazer logout
          logout();
        }
      } else {

      }
      
      setLoading(false);
    };
    
    checkAuth();
  }, []);

  // Função para fazer login
  const login = async (username, password) => {
    try {
      setError(null);
      setLoading(true);
      

        // Usar a instância 'api' que já tem a baseURL correta

      const loginResponse = await api.post('/auth/login', { username, password }, {
        timeout: 10000 // Aumentar timeout para login
      });
      
      if (loginResponse && loginResponse.data) {
        // Salvar token no localStorage
        localStorage.setItem('token', loginResponse.data.token);
        
        // Configurar o token no cabeçalho das requisições
        api.defaults.headers.common['Authorization'] = `Bearer ${loginResponse.data.token}`;
        
        // Salvar dados do usuário no estado
        setUser(loginResponse.data.user);
        
        return true;
      } else {
        throw new Error((loginResponse.data && (loginResponse.data.message || loginResponse.data.error)) || 'Token não encontrado na resposta do servidor.');
      }
    } catch (error) {
      console.error('Erro ao fazer login:', error);
      
      if (error.response && error.response.data && error.response.data.error) {
        setError(error.response.data.error);
      } else {
        setError('Erro ao fazer login. Tente novamente mais tarde.');
      }
      
      return false;
    } finally {
      setLoading(false);
    }
  };

  // Função para fazer logout
  const logout = () => {
    // Remover token do localStorage
    localStorage.removeItem('token');
    
    // Remover token do cabeçalho das requisições
    delete api.defaults.headers.common['Authorization'];
    // Também limpar dos headers padrões do axios global, se foi setado
    delete axios.defaults.headers.common['Authorization'];
    
    // Limpar dados do usuário no estado
    setUser(null);
  };

  // Função para verificar se o usuário está autenticado
  const isAuthenticated = () => !!user;

  // Função para verificar se o usuário é administrador
  const isAdmin = () => user && user.role === 'admin';

  // Valor do contexto
  const value = {
    user,
    loading,
    error,
    login,
    logout,
    isAuthenticated,
    isAdmin
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthContext;
